module.exports = {
	"articleTitle1": "Comet Coffee",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Comet Coffee",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/comet-coffee-owner-brings-love-coffee-aa",
	"articleSnippet1": "Mar 29, 2009 ... Touching on his 16 years of experience as a barista, Ann Arbor native Jim \nSaborio, owner of two-week-old Comet Coffee, brings an individual ...",
	"articleSnippet2": "Nov 17, 2011 ... After spending more than 20 years as a barista, Comet Coffee owner Jim Saborio\n, a Saline, Mich. native, opened the small, modern-styled store ...",
	"totalMisc": 0,
	"articleTitle2": "Comet Coffee owner brings love of coffee to Nickels Arcade",
	"address": "16 Nickels Arcade, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/tea.NEW_.cometcoffee.11-9-11.00024_0.jpg",
			"author": "Teresa Mathew",
			"caption": "Jim Saborio, owner of Comet Coffee in Nickels Arcade, works during his morning shift on Nov. 9."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151028/dso.FEA_.CometCoffee.10.28.15014.jpg?itok=G3EN52vB",
			"author": "David Song",
			"caption": "Ann Arbor resident Chris Liu, known by his barista name Butch Lao, prepares coffee for customers at Comet Coffee on Wednesday."
		}
	],
	"position": {
		"lat": 42.2784,
		"lng": -83.7413
	},
	"tips": [
		{
			"text": "No bathroom, and no outlets. Espresso Royale bathroom is right around the corner, nab the key from the counter in the front. Baristas never seem to mind.",
			"person": "Tess Tobin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cometcoffee.json
// module id = 853
// module chunks = 0